// Application types

const PROFILE = {
  LOADING_PROFILE: "LOADING_PROFILE",
  MY_PROFILE: "MY_PROFILE",
  UPDATING: "UPDATING",
};

export default PROFILE;
